import CdTree from "./treeview.vue";

// CdButton.install = function (Vue) {
//     Vue.component(CdButton.name, CdButton)
// }

export default CdTree;
